import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { ExportTriggerGitService } from './export-trigger-git.service';

@Injectable({ providedIn: 'root' })
export class ExportTriggerGitFactoryService extends AbstractGitFactoryService<ExportTriggerGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: ExportTriggerGitService,
    });
  }
}
